import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import Logo from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { apiError } from "@/lib/api";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created!");
      nav("/dashboard");
    } catch (err) { toast.error(apiError(err, "Sign-up failed")); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Logo size={40} /></div>
        <Card className="p-8">
          <div className="text-xs uppercase tracking-[0.2em] text-eagle-gold font-semibold mb-2">Create account</div>
          <h1 className="font-display text-3xl font-bold mb-6">Track your quotes & installs</h1>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Full name</Label>
              <Input required value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="register-name" /></div>
            <div><Label>Email</Label>
              <Input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="register-email" /></div>
            <div><Label>Phone</Label>
              <Input value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="04XX XXX XXX" data-testid="register-phone" /></div>
            <div><Label>Password</Label>
              <Input required type="password" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)} data-testid="register-password" />
              <div className="text-xs text-muted-foreground mt-1">At least 6 characters</div>
            </div>
            <Button type="submit" disabled={busy} className="w-full h-11 bg-eagle-gold text-eagle-ink hover:bg-eagle-goldHover font-semibold" data-testid="register-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-center text-muted-foreground">
            Already have an account? <Link to="/login" className="text-eagle-gold hover:underline">Sign in</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
